export const environment = {
  endpointWC: `https://application.infinitumscitech.co:33171`,
  endpointRec: `http://application.infinitumscitech.co:33151/recs/`,
  appName: 'infinitumscitech.com'
};